import PropTypes from "prop-types";
import { XIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { ComboboxItem } from "@/components/ui/combobox";

import TagBadge from "./TagBadge";

const RemoveTagButton = ({ tag, disabled, onRemove }) => (
  <Button
    type="button"
    variant="ghost"
    size="icon-xs"
    aria-label={`Remove ${tag.name}`}
    disabled={disabled}
    // The item commits a selection in its own onClick, which would apply the tag.
    onClick={event => {
      event.stopPropagation();
      onRemove(tag);
    }}
  >
    <XIcon />
  </Button>
);

// The trailing span carries the alignment because Semantic's unlayered
// `button { margin: 0 }` beats a layered `tw:ml-auto` on the close button.
const AppliedTagItem = ({ tag, isBusy, onRemove, children }) => (
  <ComboboxItem
    value={tag.id}
    disabled={!tag.enabled}
    className="tw:cursor-pointer tw:pr-1.5"
  >
    <TagBadge tag={tag} />
    <span className="tw:ml-auto tw:flex tw:items-center tw:gap-2">
      {children}
      <RemoveTagButton tag={tag} disabled={isBusy} onRemove={onRemove} />
    </span>
  </ComboboxItem>
);

RemoveTagButton.propTypes = {
  tag: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
};

AppliedTagItem.propTypes = {
  tag: PropTypes.object.isRequired,
  isBusy: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default AppliedTagItem;
